<template>
  <div>
    <OnboardingTextSection>
      Первое, что вы видете, зайдя в проект — это<br>
      дашборд с графиками. Графики будут показывать<br>
      данные по всем рекламным кампаниям проекта.
    </OnboardingTextSection>

    <OnboardingTextSection>
      <b>Данные обновляются несколько раз в день. По<br>
        рекламным площадкам — раз в 6 часов, по веб-<br>
        аналитике — раз в 12 часов.</b>
    </OnboardingTextSection>

    <OnboardingTextSection>
      Графики можно настроить, как вам удобно — <br>
      редактировать, удалять и создавать новые.
    </OnboardingTextSection>

    <OnboardingTextSection>
      Кликнув на название графика, вы автоматически<br>
      перейдете во вкладку <b>«Статистика»</b>.
    </OnboardingTextSection>
  </div>
</template>

<script>
  import OnboardingTextSection from 'onboarding/onboardings/components/OnboardingTextSection';

  export default {
    name: 'ProjectInfoStep',
    components: {OnboardingTextSection}
  };
</script>
